import React from "react";

import NoData from "../../common-components/no-data";
import EiacFilesInfo from "./eiac-files-info/eiac-files-info-text";
import Table from "../../../../../components/table-simple/table";
import { EiacFilesContainer } from "./eiac-files-style";
import { formatEaicFilesTableData } from "./helpers";
import { EiacFileType } from "../../clients-dashboard-types";
import { IGetEiacFilesCountData } from "../../../../../services/ClientsDashboardServices.dto";
import InfoModalButton from "../../common-components/info-modal-button/info-modal-button";

interface EiacFilesProps {
  data: IGetEiacFilesCountData[];
  error: string;
  fileType: EiacFileType;
}

const EiacFiles = ({ data, error, fileType }: EiacFilesProps) => {
  const eiacFilesTableData = formatEaicFilesTableData(data, fileType);

  const renderContent = () => {
    if (error) {
      return <NoData message={error} />;
    }

    if (!data) {
      return <NoData message="Genera una búsqueda para mostrar datos" />;
    }

    if (data.length <= 0) {
      return <NoData message="No existen datos para las fechas seleccionadas" />;
    }

    if (data.length && eiacFilesTableData) {
      return <Table columns={eiacFilesTableData.columns} data={eiacFilesTableData.tableData} />;
    }

    return null;
  };

  return (
    <EiacFilesContainer>
      {renderContent()}
      <div className="info-button-container">
        <InfoModalButton buttonText="Información sobre los ficheros Eiac">
          <EiacFilesInfo />
        </InfoModalButton>
      </div>
    </EiacFilesContainer>
  );
};

export default EiacFiles;
